import React from 'react';
import { X, Heart } from 'lucide-react';

const YearsPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-3 md:p-4 animate-in fade-in duration-300"
      onClick={onClose}
    >
      <div 
        className="relative max-w-md md:max-w-2xl w-full animate-in zoom-in-95 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          data-testid="popup-close-btn"
          className="absolute -top-2 -right-2 bg-white rounded-full p-1 text-gray-600 hover:text-gray-900 transition-colors z-20 shadow-lg"
        >
          <X className="w-5 h-5 md:w-6 md:h-6" />
        </button>

        {/* Main popup with background image */}
        <div className="relative rounded-lg overflow-hidden shadow-2xl">
          {/* Background image - grayscale aerial view */}
          <div 
            className="absolute inset-0 bg-cover bg-center grayscale"
            style={{
              backgroundImage: `url('https://images.unsplash.com/photo-1636215452634-29e3a662a465?w=1200&q=80')`
            }}
          />
          {/* Overlay for better text readability */}
          <div className="absolute inset-0 bg-white/85" />

          {/* Content */}
          <div className="relative z-10 p-4 md:p-8 text-center">
            {/* Title */}
            <h1 className="text-2xl md:text-4xl font-serif font-bold text-gray-900 mb-1">
              Celebrating 52 Years
            </h1>
            <h2 className="text-xl md:text-3xl font-serif font-bold text-gray-900 mb-3 md:mb-4">
              In Streetsville!
            </h2>

            {/* Red Heart Badge - responsive */}
            <div className="flex justify-center mb-3 md:mb-4">
              <div className="relative">
                <Heart 
                  className="w-36 h-36 md:w-64 md:h-64 text-red-600 fill-red-600 drop-shadow-lg" 
                  strokeWidth={0}
                />
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white -mt-1 md:-mt-3">
                  <span className="text-xs md:text-xl font-bold leading-tight text-center">52 Years Serving</span>
                  <span className="text-xs md:text-xl font-bold leading-tight text-center">Our Amazing</span>
                  <span className="text-xs md:text-xl font-bold leading-tight text-center">Community!</span>
                </div>
              </div>
            </div>

            {/* Message */}
            <p className="text-sm md:text-lg font-semibold text-gray-800 mb-2 text-center">
              We're proud to be serving Streetsville & the GTA for 52 years!
            </p>
            <p className="text-xs md:text-base text-gray-700 max-w-lg mx-auto text-center">
              Thank you to our amazing clients for your continued support! We look forward to another 
              50 years of memories and helping you with your glasses & eyecare needs!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YearsPopup;
